'use strict';

var ndarray = require("ndarray");

exports.ndarray = ndarray;